<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div class="col-md-12 col-lg-12 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
            <div class="card card-custom gutter-b">
									<div class="card-header flex-wrap border-0 pt-6 pb-0">
										<div class="card-title">
											<h3 class="card-label">Empresas 
											<span class="d-block text-muted pt-2 font-size-sm">Empresas Cliente</span></h3>
										</div>
										<div class="card-toolbar" v-if="false">
											<!--begin::Button-->
                      <router-link
                          class="btn btn-primary font-weight-bolder"
                          :to="{ name: 'create-company' }"
                        >
											<span class="svg-icon svg-icon-md">
												<!--begin::Svg Icon | path:/metronic/theme/html/demo1/dist/assets/media/svg/icons/Design/Flatten.svg-->
												<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
													<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<rect x="0" y="0" width="24" height="24"></rect>
														<circle fill="#000000" cx="9" cy="15" r="6"></circle>
														<path d="M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z" fill="#000000" opacity="0.3"></path>
													</g>
												</svg>
												<!--end::Svg Icon-->
											</span>Nueva Empresa</router-link>
											<!--end::Button-->
										</div>
									</div>
									<div class="card-body">
										<!--begin: Search Form-->
										<!--begin::Search Form-->
										<div class="mb-7">
											<div class="row align-items-center">
												<div class="col-lg-9 col-xl-8">
													<div class="row align-items-center">
														<div class="col-md-6 my-2 my-md-0">
															<div class="input-icon">
																<input type="text" class="form-control" v-model="search" placeholder="Buscar..." id="kt_datatable_search_query">
																<span>
																	<i class="flaticon2-search-1 text-muted"></i>
																</span>
															</div>
														</div><!--
														<div class="col-md-4 my-2 my-md-0">
															<div class="d-flex align-items-center">
																<label class="mr-3 mb-0 d-none d-md-block">Status:</label>
																<select class="form-control" id="kt_datatable_search_status">
																	<option value="">All</option>
																	<option value="1">Pending</option>
																	<option value="2">Delivered</option>
																	<option value="3">Canceled</option>
																	<option value="4">Success</option>
																	<option value="5">Info</option>
																	<option value="6">Danger</option>
																</select>
                                
															</div>
														</div>
														<div class="col-md-4 my-2 my-md-0">
															<div class="d-flex align-items-center">
																<label class="mr-3 mb-0 d-none d-md-block">Status:</label>
																<select class="form-control" id="kt_datatable_search_status">
																	<option value="">All</option>
																	<option value="1">Pending</option>
																	<option value="2">Delivered</option>
																	<option value="3">Canceled</option>
																	<option value="4">Success</option>
																	<option value="5">Info</option>
																	<option value="6">Danger</option>
																</select>
                                
															</div>
														</div>-->
													</div>
												</div>
												
											</div>
										</div>
										<!--end::Search Form-->
										<!--begin: Datatable-->
                    <v-data-table
                      :headers="headers"
                      :items="companies"
                      :search="search"
                      hide-default-footer
                      :items-per-page="itemsPerPage"
                      :page.sync="page"
                      @page-count="pageCount = $event"
                    >
                    <template v-slot:item="row">
                    <tr>
                      <td>{{row.item.rutEmpresaCompleto}}</td>
                      <td>{{row.item.nombre}}</td>
                      <td>{{row.item.idCliente}}</td>
                      <td>{{row.item.formaPago}}</td>
                      <td>{{row.item.canalCliente}}</td>
                      <td> {{row.item.nombresUsuarioCreador}} {{row.item.apellidosUsuarioCreador}} </td>
                       <td>{{ row.item.fechaCreacion != "0001-01-01T00:00:00" ? formatDate(row.item.fechaCreacion) : ''}}</td>
                      <td>
                         <router-link :to="{ name: 'edit-company-client', params: { tokenEmpresa: row.item.tokenEmpresa }}" class="btn btn-sm btn-clean btn-icon">
                            <i class="la la-edit"></i>
                        </router-link>
                          <!-- <a v-on:click.prevent="confirmDelete(row.item)" class="btn btn-sm btn-clean btn-icon" title="Eliminar">
                            <i class="la la-trash"></i>
                          </a>					 -->
                      </td>
                    </tr>
                    </template>
                    </v-data-table>
                     <v-pagination v-model="page" :length="pageCount"></v-pagination>
										<!--end: Datatable-->
									</div>
								</div>

        </div>
        <v-dialog
            v-model="dialog"
            max-width="290"
          >
            <v-card>
              <v-card-title class="headline">Está seguro de eliminar la empresa?</v-card-title>

              <v-card-text>
                La empresa será eliminada. En caso que la empresa posea pagos en el sistema, será deshabilitada, no eliminada 
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog = false"
                >
                  Cancelar
                </v-btn>

                <v-btn
                  color="green darken-1"
                  text
                  @click="deleteClient"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </div>
    <!--end::Dashboard-->
</template>


<script>

import { mapState } from "vuex";
import { GET_COMPANIES,DELETE_COMPANY } from "@/core/services/store/company.module";
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import {Money} from 'v-money'

import { validationMixin } from "vuelidate";
import {
  minLength
} from "vuelidate/lib/validators";

import moment from 'moment'
moment.locale( 'es' );

export default {
  mixins: [validationMixin],
  name: "dashboard",
  components: {/*Money,*/},
  data() {
    return {
      dialog:false,
      tokenDelete:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      search: '',
      headers: [
        { text: 'Rut', value: 'rutEmpresa'},
        { text: 'Nombre', value: 'nombre'},
        { text: 'Id Cliente', value: 'idCliente' },
        {text:"Forma Pago", value: "formaPago"},
        {text:"Canal Cliente", value: "canalCliente"},
        { text: 'Usuario Creador', value: 'nombresUsuarioCreador'},
        { text: 'Fecha Creación', value: 'fechaCreacion' },
        {text:'Acciones'}
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      },
      form: {
        documento: "",
        
        desde: "",
        hasta: ""
      },
    };
  },
  mounted () {
    this.getCompaniesAccount();
  },
  validations: {
      form: {
        documento: {
          minLength: minLength(3)
        },
        desde: {
          
        },
        hasta: {

        }
      }
    },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        documento: null,
        sucursal: null,
        desde: null,
        hasta: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onButtonClick(item) {
      console.log('click on ' + item.no)
    },
    getCompaniesAccount() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_COMPANIES, null)
          .then(()=>{this.$Progress.finish()});
    },
    confirmDelete(item){
      this.tokenDelete= item.tokenEmpresa;
      this.dialog = true;
    },
    deleteClient() {
      this.$Progress.start();
      this.$store
          .dispatch(DELETE_COMPANY, this.tokenDelete)
          .then(()=>{this.$Progress.finish(), this.getCompaniesAccount(),this.dialog = false});
    },
       formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    ...mapState({
      companies : state => state.company.companies,
      errors: state => state.errors
    })
  }
};
</script>
<style>
.container {
    max-width: 1185px !important;
}
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}

.v-data-table .btn, .card-toolbar .btn {
  border-radius: 0;
     -webkit-box-shadow: none; 
     box-shadow: none; 
     padding: 7px 20px 6px 20px; 
     text-transform: uppercase;
}

.card.card-custom > .card-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    min-height: 70px;
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent;
}

.card-header:first-child {
    border-radius: calc(0.42rem - 1px) calc(0.42rem - 1px) 0 0;
}
.pt-6, .py-6 {
    padding-top: 1.5rem !important;
}
.pb-0, .py-0 {
    padding-bottom: 0 !important;
}
.flex-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
}
.border-0 {
    border: 0 !important;
}
.card-header {
    padding: 2rem 2.25rem;
    margin-bottom: 0;
    background-color: #ffffff;
    border-bottom: 1px solid #EBEDF3;
}
.btn.btn-primary {
    color: #FFFFFF;
    background-color: #3699FF;
    border-color: #3699FF;
}
.btn:not(.btn-text) {
    cursor: pointer;
}
.btn {
    outline: none !important;
    vertical-align: middle;
    -webkit-transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, -webkit-box-shadow 0.15s ease;
}
.font-weight-bolder {
    font-weight: 600 !important;
}
.btn-primary {
    color: #ffffff;
    background-color: #3699FF;
    border-color: #3699FF;
    -webkit-box-shadow: none;
    box-shadow: none;
}
</style>
